import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import React, { useState, useEffect, useContext } from 'react';
import { AntDesignOutlined } from '@ant-design/icons';
import AuthContext from './AuthContext';

// 图片预加载函数
const preloadImage = (src) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = src;
    img.onload = resolve;
  });
};

const HomePage = () => {
  const { isTokenExpired, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showWelcome, setShowWelcome] = useState(true);
  const [showBirthdayText, setShowBirthdayText] = useState(false);
  const [showClickTip, setShowClickTip] = useState(true);

  const images = [
    'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/birthday_homepage.png',
    'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/c1.jpeg',
    'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/c2.jpeg',
    'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/c3.jpeg',
    'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/c4.jpeg',
    'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/c5.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/3612dcd68fb2e828ee18c73f747ee812.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/DJI_20241231_223319_144.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_2335.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_2665.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_2940.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_3083.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_3231.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_3236.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_3553.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_3676.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_3729.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_4381.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_4389.jpeg', 'https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/IMG_4395.jpeg'
  ];

  // token过期跳转
  useEffect(() => {
    if (isTokenExpired) {
      navigate('/');
    }
  }, [isTokenExpired, navigate]);

  // 图片预加载
  useEffect(() => {
    Promise.all(images.map(preloadImage)).then(() => {
      setImagesLoaded(true);
      const intervalId = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 2000);
      return () => clearInterval(intervalId);
    });
  }, [images]);

  // 点击欢迎页
  const handleWelcomeClick = () => {
    setShowClickTip(false);
    setShowBirthdayText(true);
    setTimeout(() => {
      setShowWelcome(false);
    }, 2000);
  };

  const handleSharedNotedEntry = () => {
    if (!loading) {
      const element = document.querySelector('.homepage-container');
      element.classList.add('roll-out-blurred-left');
      setTimeout(() => {
        navigate('/sharedNote');
      }, 700);
    }
  };

  const handleWordNoteEntry = () => {
    if (!loading) {
      const element = document.querySelector('.homepage-container');
      element.classList.add('roll-out-blurred-left');
      setTimeout(() => {
        navigate('/wordList');
      }, 700);
    }
  };

  return (
    <div className="homepage-container">
      {/* 欢迎页 */}
      {showWelcome ? (
        <div className="welcome-page" onClick={handleWelcomeClick}>
          <img
            src="https://jiaoyangmajiang-1330964055.cos.ap-guangzhou.myqcloud.com/birthday.png"
            alt="birthday"
            className="welcome-image pulse-animation"
          />
          {showBirthdayText && (
            <h1 className="birthday-text tracking-in-contract">🎉 BBB生日快乐！🎂</h1>
          )}
          {showClickTip && (
            <div className="click-tip bounce-animation">点击进入</div>
          )}
        </div>
      ) : (
        // 主页面内容
        <>
          <div className="image-carousel">
            {imagesLoaded && images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Carousel ${index}`}
                className={`carousel-image ${index === currentImageIndex ? 'active' : ''}`}
              />
            ))}
          </div>
          <h1 className="animated-text">开启崭新的一页～</h1>
          <div className="button-container">
            <Button
              type="primary"
              size="large"
              icon={<AntDesignOutlined />}
              onClick={handleSharedNotedEntry}
                disabled={loading}
              >
                进入
              </Button>
              <Button
                type="primary"
                size="large"
                icon={<AntDesignOutlined />}
                onClick={handleWordNoteEntry}
                disabled={loading}
              >
                单词本
              </Button>
            </div>
        </>
      )}
    </div>
  );
};

export default HomePage;